<template lang='pug'>
  blue-layout( :user='user' :account='account' :biz='biz' )
    #account.view
      bf-notice( :message='message' @close='message = ""' )

      transition( name='appear' )
        bf-wrapper.max-960
          profile-header( :account='account' )

          section.auth
            table
              tr
                td 
                  bf-flex.space-between
                    label {{$t("Login with")}}: 
              tr
                td
                    span Google
                td
                  bf-flex.space-between
                    bf-button.bright( v-if='!providers.find( p => p.providerId == "google.com" )' @click.native='link( google )' )
                      template( v-slot:text ) {{$t("Enable")}}
                    bf-button.inactive( v-else disabled )
                      template( v-slot:text ) {{$t("Linked")}}
                    span
                      span Facebook
                      bf-button.bright.fb( v-if='!providers.find( p => p.providerId == "facebook.com" )' @click.native='link( facebook )' )
                        template( v-slot:text ) {{$t("Enable")}}
                      bf-button.inactive.fb( v-else disabled )
                        template( v-slot:text ) {{$t("Linked")}}

              template( v-if='!providers.find( p => p.providerId == "password" ) && providers.some( p => p.providerId != "phone" )' )
                tr
                  td {{$t("Email")}}
                  td
                    input( type='text' v-model='email' )
                tr
                  td {{$t("Password")}}
                  td
                    input( type='text' v-model='pass' )
                tr
                  td {{$t("Confirm Password")}}
                  td
                    input( type='text' v-model='confirm' )
                tr
                  td 
                  td
                    bf-flex.centered
                      bf-button.bright( @click.native='modal = true' )
                        template( v-slot:text ) {{$t("Enable")}}
              
          section#membership
            .title
              span.banner {{$t("MEMBERSHIP")}}
            .center
              router-link.link(:to="{ name: 'pricetable', params: {} }")
                span Feature List
            bf-flex.space-evenly
              span
                label {{$t("Basic Seller (Free)")}}
                input( ref='basic' type='radio' v-model='membership' value='basic' @click='downgrade' )
              span
                h5 {{$t("Value Merchant ($15/mo)")}}
                input( ref='value' type='radio' v-model='membership' value='value' )

            .center( v-if='account.merchant != "value"' v-show='!subscribing' )
              stripe( 
                v-show='membership == "value"' 
                @subscribing='test'
                @subscribed='subscribing = false'
              )

              
            bf-flex.centered.column.sub-info( v-else-if='account.sub && !canceling && !subscribing' ) 
              h5 {{$t("You are subscribed to Value Merchant")}}
              bf-divider.borderless.mini
              p 
                span {{$t("Your next payment will be automatically charged on: ")}}
                span.date {{ new Date( account.sub.current_period_end * 1000 ).toLocaleDateString() }}

            bf-flex.centered.column.sub-info( v-if='subscribing' )
              h5.warn {{$t("Subscribing.  Please wait a few seconds...")}}

          section#charges
            h6 {{$t("Billing History")}}
            charges( :user='user' :account='account' v-if=' user && account.id && account.stripe_id' )
</template>

<script>
  import { firebase, db, fc } from '@/main'
  import BaseModal from '@/components/modals/base'
  import CloseButton from '@/components/buttons/close'
  import LinkablePasswordForm from '@/components/forms/linkable/password'
  import ModalWrapper from '@/components/modals/wrapper'
  import ProfileHeader from '@/components/profile-header'
  import Stripe from '@/components/payments/stripe'
  import Charges from '@/components/payments/charges'
  import { View, Animatable } from '@/mixins/view'

  export default {
    name: 'account.view',

    mixins: [ View, Animatable ],

    components: {
      BaseModal,
      CloseButton,
      LinkablePasswordForm,
      ModalWrapper,
      ProfileHeader,
      Stripe,
      Charges
    },

    data() {
      return {
        google: new firebase.auth.GoogleAuthProvider(),
        facebook: new firebase.auth.FacebookAuthProvider(),
        password: new firebase.auth.EmailAuthProvider(),
        linkables: [ 'facebook.com', 'google.com', 'password' ],
        modal: false,
        message: '',
        ready: false,
        email: '',
        pass: '',
        confirm: '',
        membership: this.$route.params.preset,
        canceling: false,
        subscribing: false
      }
    },

    computed: {
      providers() {
        if ( this.user ) return this.user.providerData
        else return []
      },

      ids() {
        return this.providers.map( p => p.providerId )
      },

      linkable() {
        return this.linkables.some( linkable => !this.ids.includes( linkable ) )
      }
    },

    watch: {
      account( c, p ) {
        this.sync( c )
      }
    },

    methods: {
      test() {
        console.log('subbing')
        this.subscribing = true
      },

      downgrade( e ) {
        if ( confirm( 'Are you sure you want to downgrade from Value to Basic?' ) ) {
          this.canceling = true
          this.membership = 'basic'
          fc.httpsCallable( 'cancel' )().then( r => console.log( r.data ) )
        }
        else e.preventDefault()
      },

      sync( acc ) {
        if ( acc.id ) {
          if ( !acc.merchant ) this.$router.go( -1 )
          else {
            if ( this.$route.params.preset ) this.membership = this.$route.params.preset
            else this.membership = acc.merchant
          }
        }
      },

      link( provider ) {
        this.user.linkWithRedirect( provider )
        .then(  )
        .catch( e => alert( e.message ) )
      },

      linked( usr ) {
        this.modal = false
        this.$emit( "password-linked", usr )
      },

      link_email() {
        let credential = firebase.auth.EmailAuthProvider.credential( this.email, this.pass )
        this.user.linkWithCredential( credential ).then( cred => 
          this.$emit( 'password-linked', cred.user )
        ).catch( e => alert( e.message ) )
      },
    },

    created() {
      this.sync( this.account )
    }
  }
</script>

<style scoped lang='stylus'>
  section
    background white
    border 2px solid rgb( 216 216 216 )
    border-radius 5px
    padding 10px
    margin 32px 0

  #membership
    padding 0 0
    .sub-info
      font-weight bold
      .date
        color dodgerblue
        font-size 1.2em
        margin-left .5em

    .title
      text-align center
      background-color rgb(102 139 211)
      padding 10px
    
    .banner
      font-weight bold
      font-size 1.2em
      color white
      align-items center
    
    .center
      padding 10px
      text-align center
      color blue
      cursor hand

    background-color rgb(226 253 255)
    .bf-flex
      align-items center
      margin 16px 0
    .stripe >>> .bf-button
      margin-left auto

  .warn
    border 1px solid red
    padding 10px 10px
    background white

  input
    border 1px solid rgb( 216 216 216 )
    border-radius 3px
    padding 4px 16px
    background rgb( 240 240 240 )
    width 100%
    box-sizing border-box

  .auth
    label
      font-weight 800
    table
      width 100%
      tr
        td
          // font-weight bold
          color black
          padding 8px
          .fb
            margin-left 12px
        td:first-child
          text-align right
  .email
    background gray
    border-radius 50%
    color white
    height 36px
    width 36px
    margin-left 8px

  .linkables
    h2
      margin 48px 0 24px 0
    .bf-flex
      align-items center
    img
      width 36px
      margin 0 12px
</style>
